/*****************************************************************************************************************************************************
 * Diagnostic monitoring *
 ****************************************************************************************************************************************************/
define('commons/monitoring/diagnostic-monitoring',['jquery', 'commons/monitoring/message-monitoring', 'dygraph'], function($, MessageMonitoring) {

    var DiagnosticMonitoring = function(seriesArray) {
        // Call parent init method
        MessageMonitoring.apply(this, Array.prototype.slice.call(arguments, 1));
        var data = {};
        for (var i = 0; i < seriesArray.length; i++) {
            var array = new Array(200).map(function() {
                return 0;
            });
            data[seriesArray[i]] = array;
        }
        this.values = {
            data: data,
            time: 0,
            step: 10000
        };
    };

    // Inherit from MessageMonitoring
    for ( var element in MessageMonitoring.prototype) {
        DiagnosticMonitoring.prototype[element] = MessageMonitoring.prototype[element];
    }

    DiagnosticMonitoring.prototype.loadData = function(params) {
        this.chart.addClass("loading");
        var result = this.processResponse(this.values);
        if (result && result.data.length > 0) {
            if (this.dygraph === null) {
                this.chart.css("text-align", "left").css("height", this.chart.data('height')).empty();
                this.dygraph = new Dygraph(this.chart.get(0), result.data, $.extend({
                    labels: result.labels,
                    fillGraph: true,
                    connectSeparatedPoints: true,
                    labelsDiv: this.label.get(0),
                    hideOverlayOnMouseOut: false,
                    legend: "always",
                    axisLabelFontSize: 12
                }, result.drawOptions));
            } else {
                this.dygraph.updateOptions({
                    labels: result.labels,
                    file: result.data
                });
            }
        } else {
            this.chart.css("text-align", "center").css("height", "auto").html("No data to display");
            this.dygraph = null;
        }
        this.chart.removeClass("loading");
    };

    return DiagnosticMonitoring;
});
